/**
 * CR-8252 — what the Suppliers page's Add menu offers this user.
 *
 * Each option mirrors the server rule behind it, so the menu never offers an
 * add that would dead-end in a 403:
 * - supplier: compliance off (added directly), or the user has compliance
 *   (onboarding.access.add_supplier_refusal);
 * - group: Helix operators or a customer admin (IsHelixOrCustomerAdmin);
 * - logistics: Call Off is on.
 */
export interface AddMenuInputs {
  complianceOn: boolean;
  canUseCompliance: boolean;
  companyType?: string;
  isCompanyAdmin?: boolean;
  showLogisticsOption: boolean;
}

export interface AddMenuOptions {
  onboard: boolean;
  supplier: boolean;
  group: boolean;
  logistics: boolean;
  /** False when nothing is offered: the page shows no Add button at all. */
  any: boolean;
}

/**
 * Resolve the Add menu's options.
 *
 * @param inputs - the tenant switch, the user's compliance access and role
 * @returns which options to show, and whether the Add button shows at all
 */
export function addMenuOptions(inputs: AddMenuInputs): AddMenuOptions {
  const supplier = !inputs.complianceOn || inputs.canUseCompliance;
  const group = inputs.companyType === 'helix'
    || (inputs.companyType === 'customer' && !!inputs.isCompanyAdmin);
  const logistics = inputs.showLogisticsOption;
  return {
    onboard: inputs.canUseCompliance,
    supplier,
    group,
    logistics,
    any: supplier || group || logistics,
  };
}
